import React from 'react';
import { Check } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-gray-900 flex items-center justify-center px-4 pt-12 pb-16 md:pt-20 md:pb-20 overflow-hidden" data-id="element-72">
      {/* Background image with blur overlay */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/uoSXcZ2TTXFhqetrnyUWi4/Firefly_Gemini_Flash-12.png')`,
      filter: 'blur(3px)',
      transform: 'scale(1.05)'
    }} data-id="element-73" />
      {/* Dark overlay for text contrast */}
      <div className="absolute inset-0 bg-blue-950/70" data-id="element-74" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-75">
        {/* Badge */}
        <div className="inline-block mb-6" data-id="element-76">
          <div className="bg-white/15 backdrop-blur-sm text-white border border-white/30 px-6 py-2 rounded-full text-sm font-semibold inline-flex items-center gap-2" data-id="element-77">
            <span data-id="element-78">⚡</span>
            PARA DOCENTES DE TEORÍA DE LAS ORGANIZACIONES
          </div>
        </div>

        {/* Main Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-4 leading-tight drop-shadow-lg" data-id="element-79">
          ORGANIZA TODO TU AÑO DE
          <br data-id="element-80" />
          <span className="text-blue-300" data-id="element-81">
            <span className="block sm:inline" data-id="element-82">TEORÍA DE LAS</span>{' '}
            <span className="block sm:inline" data-id="element-83">ORGANIZACIONES</span>
            <br className="hidden sm:block" data-id="element-84" />
            <span className="block" data-id="element-85">SIN ESTRÉS</span>
          </span>
        </h1>

        {/* Product Image */}
        <div className="my-8 md:my-10 flex justify-center" data-id="element-86">
          <img src="https://cdn.magicpatterns.com/uploads/57bv5JRmgCbzGNfokFwHnF/MOCKUP_PRINCIPAL_TDLO.png" alt="Teoría de las Organizaciones 360" className="max-w-sm md:max-w-md w-full h-auto drop-shadow-2xl" data-id="element-87" />
        </div>

        {/* Product Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3 drop-shadow" data-id="element-88">
          TEORÍA DE LAS ORGANIZACIONES 360
        </h2>

        {/* Value Proposition */}
        <p className="text-lg md:text-xl text-blue-100 mb-1 max-w-3xl mx-auto" data-id="element-89">
          Sistema completo de actividades, proyectos y evaluaciones listos para
          usar.
        </p>
        <p className="text-base md:text-lg font-semibold text-white/90 mb-8" data-id="element-90">
          Todo el año de Teoría de las Organizaciones resuelto sin planificar
          nada desde cero.
        </p>

        {/* CTA Button */}
        <div className="mb-4" data-id="element-91">
          <a href="#compra" className="inline-block bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-xl shadow-2xl shadow-blue-500/40 hover:shadow-blue-500/60 transition-all px-12 py-5" data-id="element-92">
            <div className="font-bold text-xl uppercase tracking-wide" data-id="element-93">
              QUIERO ACCESO INMEDIATO
            </div>
            <div className="text-sm mt-1 opacity-95" data-id="element-94">
              Pago 100% seguro y encriptado
            </div>
          </a>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 text-sm text-white/80 mt-6" data-id="element-95">
          <div className="flex items-center gap-2" data-id="element-96">
            <Check className="w-5 h-5 text-green-400" strokeWidth={3} data-id="element-97" />
            <span data-id="element-98">Descarga inmediata</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-99">
            <Check className="w-5 h-5 text-green-400" strokeWidth={3} data-id="element-100" />
            <span data-id="element-101">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-102">
            <Check className="w-5 h-5 text-green-400" strokeWidth={3} data-id="element-103" />
            <span data-id="element-104">Acceso de por vida</span>
          </div>
        </div>
      </div>
    </section>;
}